import { Box } from "@mui/material";
import CustomToolTip from "../../../../components/CustomTooltip";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { IntegrationsMapping } from "../IntegrationsMapping";

export default function IntegrationImage({
  name,
  width,
  showToolTip = true,
  newLogo = false,
  style = {},
}) {
  return (
    <>
      {showToolTip ? (
        <CustomToolTip title={IntegrationsMapping[name]?.displayName}>
          <Box sx={{ display: "flex", justifyItems: "center" }}>
            <SvgToIcon
              IconLogo={
                // TODO: replace all the old logos with the new ones in another PR https://linear.app/breeze-security/issue/DEV-1852/use-the-newlogo-icons-around-the-platform
                newLogo
                  ? IntegrationsMapping[name]?.newLogo
                  : IntegrationsMapping[name]?.logo
              }
              style={{
                ...style,
              }}
              width={width}
            />
          </Box>
        </CustomToolTip>
      ) : (
        <Box sx={{ display: "flex", justifyItems: "center" }}>
          <SvgToIcon
            IconLogo={
              // TODO: replace all the old logos with the new ones in another PR https://linear.app/breeze-security/issue/DEV-1852/use-the-newlogo-icons-around-the-platform
              newLogo
                ? IntegrationsMapping[name]?.newLogo
                : IntegrationsMapping[name]?.logo
            }
            width={width}
            style={{
              ...style,
            }}
          />
        </Box>
      )}
    </>
  );
}
